import { useMemo } from 'react';

import { ClientCore } from 'client-core';
import { UnlockMethods } from 'client-web-sdk';

import useAccountState from 'src/util/clientCore/useAccountState';

export default function useUnlockMethods(clientCore: ClientCore): {
  unlockMethods: UnlockMethods;
} {
  const accountState = useAccountState(clientCore);
  return useMemo(() => {
    const unlockMethods: UnlockMethods = {
      push: accountState.hasPushAuthenticator(),
      securityKey: accountState.isWebauthnPossibleForSession(clientCore.getSessionId()),
      mobileSafari: false,
    };
    return { unlockMethods };
  }, [accountState, clientCore]);
}
